
import * as Ladda from "ladda"
import "ladda/css/ladda.scss"

window.Ladda = window.Ladda || Ladda;
const DELAY_TIME = 500

$(".btn-load-more").each(function () {
    prepareLoadMore($(this))
});

/**
 * Pass in button to load next page of results, 
 * but container is set
 */
function prepareLoadMore(submitBtn){

    var ladda = Ladda.create(submitBtn[0]);
    var container = $("#infinite-news-grid")

    submitBtn.on("click", function(event){
        event.preventDefault()

        var nextPageLink = submitBtn.attr('href')
        if(!nextPageLink) return

        ladda.start()

        console.log("START")
        setTimeout(() => {
            console.log("CALLED")

            $.getJSON(nextPageLink)
                .done(function(data) {

                    if(data.nextPage){
                        submitBtn.attr("href", "?page=" + data.nextPage)
                    } else {
                        submitBtn.attr("href", "#")
                        submitBtn.addClass("disabled")
                        submitBtn.text("No more news")
                    }

                    $.each(data.news, function (_, entry) {
                        container.append(entry)
                    })
                })
                .fail(function() {
                    console.log( "error" );
                })
                .always(function() {
                    ladda.stop()
                });

        }, DELAY_TIME)


    })

}